export const labels = {
	placeholder: {
		label: "Label.MobileCreator.BottomMenu.Qr.Placeholder",
		default: "www.smartphoto.com",
	},
};
